import { render, staticRenderFns } from "./output_list.vue?vue&type=template&id=2a66b52e&scoped=true"
import script from "./output_list.vue?vue&type=script&lang=js"
export * from "./output_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66b52e",
  null
  
)

export default component.exports